import moment from "moment";

export interface IUser {
  id?: number;
  username: string;
  first_name: string
  last_name: string;
  email?: string;
  is_superuser: boolean;
  is_staff: boolean;
  login_method: string;
  resent_otp_delay:number;
  is_business: boolean;
  is_verified: boolean;
  is_request_verified_pending: boolean;
  avatar: string;
  language?: string;
  last_login: string;
}

export interface IResultVerify {
  message: string;
  success: boolean;
}

export class UserModel {
  id?: number;
  username: string;
  password: string;
  fullname: string;
  isSuperUser: boolean;
  isStaff: boolean;
  resendOtpDelay:number;
  email: string;
  pic: string;
  loginMethod: string;
  occupation: string;
  companyName: string;
  isBusiness: boolean;
  isVerified: boolean;
  isRequestVerifiedPending: boolean;
  phone: string;
  // personal information
  firstname: string;
  lastname: string;
  website: string;
  lastLogin?: moment.Moment;
  // account information
  language: string;
  timeZone: string;
  communication: {
    email: boolean;
    sms: boolean;
    phone: boolean;
  };
  // email settings
  emailSettings?: {
    emailNotification: boolean;
    sendCopyToPersonalEmail: boolean;
    activityRelatesEmail: {
      youHaveNewNotifications: boolean;
      youAreSentADirectMessage: boolean;
      someoneAddsYouAsAsAConnection: boolean;
      uponNewOrder: boolean;
      newMembershipApproval: boolean;
      memberRegistration: boolean;
    };
    updatesFromKeenthemes: {
      newsAboutKeenthemesProductsAndFeatureUpdates: boolean;
      tipsOnGettingMoreOutOfKeen: boolean;
      thingsYouMissedSindeYouLastLoggedIntoKeen: boolean;
      newsAboutMetronicOnPartnerProductsAndOtherServices: boolean;
      tipsOnMetronicBusinessProducts: boolean;
    };
  };

  setUser(user: IUser) {
    this.id = user.id;
    this.username = user.username || '';
    this.fullname = `${user.first_name} ${user.last_name}`;
    this.firstname = user.first_name;
    this.lastname = user.last_name;
    this.loginMethod = user.login_method;
    this.resendOtpDelay = user.resent_otp_delay;
    this.isSuperUser = (user.is_superuser == undefined) ? false : user.is_superuser;
    this.email = user.email || '';
    this.pic = user.avatar || './assets/media/avatars/blank.png';
    this.isBusiness = user.is_business;
    this.isVerified = user.is_verified;
    this.isRequestVerifiedPending = user.is_request_verified_pending;
  }

  static fromObject(user: IUser): UserModel {
    let obj = new UserModel();
    obj.id = user.id;
    obj.username = user.username || '';
    obj.fullname = `${user.first_name} ${user.last_name}`;
    obj.firstname = user.first_name;
    obj.loginMethod = user.login_method;
    obj.resendOtpDelay = user.resent_otp_delay;
    obj.resendOtpDelay = user.resent_otp_delay;
    obj.lastname = user.last_name;
    obj.isSuperUser = (user.is_superuser == undefined) ? false : user.is_superuser;
    obj.email = user.email || '';
    obj.pic = user.avatar || './assets/media/avatars/blank.png';
    obj.isVerified = user.is_verified;
    obj.lastLogin = user.last_login ? moment(user.last_login) : undefined;
    obj.isRequestVerifiedPending = user.is_request_verified_pending;
    return obj;
  }
}
